import type { ReactNode } from 'react';
import React, { useReducer } from 'react';
type args = {
  iterationNumber?: number;
  items: ReadonlyArray<ReactNode>;
  forceInitialShowingItemsNumber?: number;
};
export const usePaginate = ({
  iterationNumber = 5,
  items = [],
  forceInitialShowingItemsNumber = 0,
}: args): {
  paginatedItems: ReadonlyArray<ReactNode>;
  totalOfItems: number;
  itemsShowing: number;
  seeMoreAction: () => void;
  shouldShowSeeMore: boolean;
} => {
  const totalOfItems = items.length;
  const [showThisNumberOfItems, setShowThisNumberOfItems] = useReducer((state: number) => {
    const newNumberOfItemsToShow = state + iterationNumber;
    return newNumberOfItemsToShow > totalOfItems ? totalOfItems : newNumberOfItemsToShow;
  }, iterationNumber);
  const forcedOrNotShowingItemNumber = forceInitialShowingItemsNumber || showThisNumberOfItems;
  const itemsToShow = items.slice(0, forcedOrNotShowingItemNumber);
  const itemsShowing =
    forcedOrNotShowingItemNumber < totalOfItems ? forcedOrNotShowingItemNumber : totalOfItems;
  return {
    paginatedItems: itemsToShow,
    totalOfItems,
    itemsShowing: itemsShowing,
    seeMoreAction: setShowThisNumberOfItems,
    shouldShowSeeMore: totalOfItems > itemsToShow.length,
  };
};
